export const mlContentColumns = ({showSource, subTitle = undefined}) => [
    showSource && {
        width: "1%",
        className: "source",
        label: "SOURCE",
        domAttrs: {
            "xd-qa-type": "label",
            "xd-qa-name": "Source",
        },
    },
    {
        width: "60%",
        className: "name",
        label: "ADDRESS LIST",
        subTitle,
        sortable: {
            defaultDirection: "asc",
        },
        domAttrs: {
            "xd-qa-type": "label",
            "xd-qa-name": "Address List Name",
        },
    },
    {
        width: "1%",
        className: "count",
        label: "QTY",
        sortable: {
            defaultDirection: "desc",
        },
        domAttrs: {
            "xd-qa-type": "label",
            "xd-qa-name": "Qty",
        },
    },
    {
        width: "40%",
        className: "created",
        label: "CREATED",
        sortable: {
            defaultDirection: "desc",
        },
        domAttrs: {
            "xd-qa-type": "label",
            "xd-qa-name": "Created",
        },
    },
    {
        width: "1%",
        className: "actions",
        label: "ACTIONS",
        domAttrs: {
            "xd-qa-type": "label",
            "xd-qa-name": "Actions",
        },
    },
].filter(v=>v);
